import { render, staticRenderFns } from "./edu_liyou_coupon_mng_page.vue?vue&type=template&id=45253c42"
import script from "./edu_liyou_coupon_mng_page.vue?vue&type=script&lang=js"
export * from "./edu_liyou_coupon_mng_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45253c42')) {
      api.createRecord('45253c42', component.options)
    } else {
      api.reload('45253c42', component.options)
    }
    module.hot.accept("./edu_liyou_coupon_mng_page.vue?vue&type=template&id=45253c42", function () {
      api.rerender('45253c42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/edu_liyou/coupon/edu_liyou_coupon_mng_page.vue"
export default component.exports